export const iconFontAwesomeMediaplaybackShuffle = (
	<i className="fa-solid fa-shuffle"></i>
);
